import { AloftPrice } from '@aloft/toolkit-shared';

import { get } from 'lodash';

import { AdjustmentRollups, FeaturesAndAdjustments } from '../types.js';

export const hasAdjustments = (
  comps: Record<string, Partial<FeaturesAndAdjustments> & AdjustmentRollups>,
  path: keyof FeaturesAndAdjustments,
): boolean => {
  return Boolean(
    Object.values(comps).find(
      (comp) =>
        get(comp, `${path}.adjustment`) &&
        (get(comp, `${path}.adjustment`) as unknown as AloftPrice | undefined)?.toNumericPrice() !==
          0,
    ),
  );
};
